import type { PublicSlotKey } from '@/apilib';
import type { CustomAuthenticationApi } from './customAuthenticationAPI';

export const CustomAuthenticationApiKey: PublicSlotKey<CustomAuthenticationApi> =
  {
    name: 'CustomAuthenticationApiKey',
    public: true,
  };
